/* eslint-disable
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

import PreviewModalTemplate from 'components/PreviewModalTemplate';
import notifications from 'notifications';
import * as popup from 'Popup';
import * as analytics from 'analytics/Analytics';

class PreviewModalView extends Backbone.View {
  static initClass() {
    this.prototype.template = PreviewModalTemplate;

    this.prototype.events = {
      'click .prev-btn': function () {
        return this.gotoPage(this.currentPage - 1);
      },
      'click .next-btn': function () {
        return this.gotoPage(this.currentPage + 1);
      },
      'click .first-btn': function () {
        return this.gotoPage(0);
      },
      'click .last-btn': function () {
        return this.gotoPage(this.pagination.pages.length - 1);
      },
    };
  }

  readyDownload(url) {
    this.popup
      .$('.js-submit')
      .removeClass('disabled')
      .button('reset')
      .attr('target', '_blank')
      .attr('href', url)
      .click(() => {
        analytics.track('editor', 'downloaded_pdf', this.trackMetadata);
      });
  }

  gotoPage(pageIndex) {
    this.currentPage = pageIndex;

    const onFirst = pageIndex === 0;
    const onLast = pageIndex === this.pagination.pages.length - 1;

    this.$('.prev-btn').prop('disabled', onFirst);
    this.$('.first-btn').prop('disabled', onFirst);
    this.$('.next-btn').prop('disabled', onLast);
    this.$('.last-btn').prop('disabled', onLast);
    this.$('.page-count').text(`Page ${pageIndex + 1} of ${this.pagination.pages.length}`);

    this.$('svg.preview-container').empty();
    return this.$('svg.preview-container').append(this.pagination.pages[this.currentPage].svg);
  }

  initialize(options) {
    // A function that takes in CSS and gives back a Pagination.
    this.paginate = options.paginate;
    this.trackMetadata = options.trackMetadata || {}; // for analytics.track
    this.landscape = options.landscape || false;
    return (this.filename = options.filename);
  }

  showPreview(pagination) {
    this.pagination = pagination;
    return this.gotoPage(0);
  }

  initiate() {
    this.$('.status').text('Retrieving formatting...');
    return $.get('/static/build/svg.css')
      .then((css) => {
        css = css.split('\n').join('').split('\r').join('');
        this.$('.status').text('Creating pages...');
        const pagination = this.paginate(css);
        let message = 'Generating PDF...';
        if (pagination.truncated()) {
          message += `<br/>Note: For performance reasons, only the first ${pagination.pages.length} pages of
          the PDF will be generated. To see more of your alignment, consider adjusting the visibility settings
          or exporting multiple selections.`;
        }
        this.$('.status').html(message);
        this.showPreview(pagination);
        return this.pagination.toPDF(this.filename);
      })
      .fail(notifications.notifyError)
      .done((url) => {
        const $status = this.$('.status');
        $status.html('Done.');
        setTimeout(() => $status.slideUp(), 2000);
        this.readyDownload(url);
      });
  }

  render() {
    this.$el.html(this.template({landscape: this.landscape}));

    this.$('.prev-btn').prop('disabled', true);
    this.$('.first-btn').prop('disabled', true);
    this.$('.next-btn').prop('disabled', true);
    this.$('.last-btn').prop('disabled', true);

    this.popup = new popup.Confirm({title: 'PDF Preview', msg: this.el})
      .linkChoice('Download', 'btn-af-success js-submit disabled')
      .choice('Cancel', 'btn-af-default js-cancel');
    this.popup.show();

    this.popup.$('.js-submit').data({loadingText: 'Preparing PDF...'}).button('loading');
    this.popup.$('.js-submit').attr('data-test-component', 'PreviewModelView');
    this.popup.$('.js-submit').attr('data-test-element', 'downloadButton');

    this.initiate();
    return this;
  }
}
PreviewModalView.initClass();

export default PreviewModalView;
